import type {
  IframeHandshakeResponse,
  IframeHasStorageAccessResponse,
  IframeRequest,
} from '@/common/interop/iframe';

import { hasStorageAccess } from './has-storage-access';
import { tunnel } from './tunnel';
import { createWebSocket } from './websocket';
import { postMessageToPort } from '../../common/port';

export function createHandlePortMessage() {
  let ws: WebSocket | undefined;

  return async function handlePortMessage(
    port: MessagePort,
    { data }: MessageEvent,
  ) {
    const request: IframeRequest = JSON.parse(data);

    switch (request.topic) {
      case 'connect':
        ws?.close();
        ws = createWebSocket(port, request);
        break;
      case 'send':
        ws?.send(JSON.stringify({ action: 'send', message: request.message }));
        break;
      case 'close':
        ws?.close();
        break;
      case 'has-storage-access':
        postMessageToPort<IframeHasStorageAccessResponse>(port, {
          topic: 'has-storage-access',
          hasStorageAccess: await hasStorageAccess(),
        });
        break;
      case 'tunnel':
        postMessageToPort(port, await tunnel(request));
        break;
    }
  };
}

const handlePortMessage = createHandlePortMessage();
export function handleWindowMessage({ ports }: MessageEvent) {
  if (!ports.length) return;

  window.removeEventListener('message', handleWindowMessage);

  const port = ports[0];
  port.addEventListener('message', handlePortMessage.bind(undefined, port));
  port.start();

  postMessageToPort<IframeHandshakeResponse>(port, { topic: 'handshake' });
}
